import languageMap from 'sources/locale/en';

function loc(key) {
  return languageMap[key] || '';
}

export default loc;



// WEBPACK FOOTER //
// ./src/sources/locale/loc.js